import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types';
import { getOfflineFilesListFunction } from '@/modules/OfflineFiles/queries/getOfflineFilesList/getOfflineFilesListQueryFunction';
import { getNextPage } from '@/modules/FileList/utils/getNextPage';
import { infiniteQueryOptions } from '@tanstack/react-query';

export const getOfflineFilesListQueryOptions = () => {
  return infiniteQueryOptions({
    queryKey: ['GetOfflineFilesList'],
    queryFn: ({ pageParam }) =>
      getOfflineFilesListFunction({ page: pageParam }),
    enabled: true,
    initialPageParam: 1,
    getNextPageParam: getNextPage,
    select: (data) => {
      return {
        ...data,
        pages: data.pages.map((page) => {
          return {
            ...page,
            results: page.results.map((item) => ({
              ...item,
              detailCardItems: [
                {
                  type: 'default',
                  keyName: 'شناسه پرونده',
                  value: item.order_id,
                  dirLtr: true,
                },
                {
                  type: 'default',
                  keyName: 'نام',
                  value: item.full_name,
                  dirLtr: true,
                },
                {
                  type: 'default',
                  keyName: 'زمان بازدید',
                  value: item.visit_date
                    ? `${item.visit_date} ${item.visit_time}`
                    : 'تعین نشده',
                },
              ] as DetailCardItemData[],
            })),
          };
        }),
      };
    },
  });
};
